import React from "react";
import {
    Empty,
    List as AntList,
    Button,
    Icon,
    Upload,
    Card
} from "antd";
import PropTypes from "prop-types";
import { STATE_STATUS } from "constants";
import { getAuthToken } from "utilities/auth";
import { createDropTarget } from "hocs/drag-and-drop";
import { FILE_TYPE } from "constants/drag-drop-types";


const ListItem = AntList.Item;

class DirectFileUpload extends React.Component {
    state = {
        status: STATE_STATUS.IDLE
    };
    render() {
        return (
            <Upload
                {...{
                    directory: false, // Upload Directory Support
                    multiple: true, // Upload Multiple files support,
                    action:
                        `${process.env.BASE_URL}/company/documents/create/`,
                    showUploadList: false,
                    headers: {
                        Authorization: `Bearer ${getAuthToken().authToken}`
                    },
                    data: file => ({
                        file_name: file.name,
                        company: this.props.companyId
                    }),
                    onChange: ({ file }) => {
                        if (file.status === "uploading") {
                            this.setState({
                                status: STATE_STATUS.ENGAGED
                            });
                        }
                        if (file.status === "done") {
                            this.setState(
                                {
                                    status: STATE_STATUS.IDLE
                                },
                                () => this.props.uploadFiles([file.response])
                            );
                        }
                    }
                }}
            >
                <Button type={"default"} disabled={this.props.recreditViewOnlyPermission}>
                    Upload{" "}
                    <Icon
                        type={
                            this.state.status === STATE_STATUS.ENGAGED
                                ? "loading"
                                : "upload"
                        }
                        loading={this.state.status === STATE_STATUS.ENGAGED}
                    />
                </Button>
            </Upload>
        );
    }
}

DirectFileUpload.propTypes = {
    companyId: PropTypes.number,
    uploadFiles: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const DropTargetCard = createDropTarget({
    dropType: FILE_TYPE,
    dropResponse: props => {
        return {
            case: props.caseId,
            company: props.companyId,
            associate: props.associateId ? props.associateId : null,
            company_bank: props.bankId ? props.bankId : null,
            document: props.documentId,
            document_type: props.documentType
        };
    }
})(Card);

class BankDocumentView extends React.Component {
    deactivateDocument = documentId => {
        const document = this.props.documents.find(_ => _.id === documentId);
        this.props.updateDocument(
            this.props.caseId,
            this.props.companyId,
            documentId,
            document.set("company", this.props.companyId).set("is_active", false).set("file", document.file && document.file.id)
        );
    };
    uploadAndAttachFile = (documentId, documentType, files) => {
        const result = {
            case: this.props.caseId,
            company: this.props.companyId,
            associate: this.props.associateId ? this.props.associateId : null,
            company_bank: this.props.bankId ? this.props.bankId : null,
            document: documentId,
            document_type: documentType
        };
        this.props.uploadFiles(files);
        files.map(_ =>
            this.props.attachDocument(result.document, result.case, {
                ...result,
                file: _.id
            })
        );
    };

    renderList = (_) => {
        return (
            <AntList itemLayout={"horizontal"}>
                {this.props.documents.filter(__ => __.document === _.id)
                    .size === 0 ? (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    ) : null}
                {this.props.documents
                    .filter(__ => __.document === _.id)
                    .sort((a, b) =>
                        a.modified_date.isBefore(b.modified_date)
                            ? 1
                            : -1
                    )
                    .map(__ => (
                        <ListItem
                            key={__.id}
                            actions={
                                this.props.deletable
                                    ? [
                                        <Button
                                            type="link"
                                            onClick={this.props.viewDocument.bind(
                                                null,
                                                __.file.file_name,
                                                __.file.file
                                            )}
                                            key={"view-button"}
                                        >
                                                View
                                        </Button>,
                                        <Button
                                            type="link"
                                            onClick={this.deactivateDocument.bind(
                                                null,
                                                __.id
                                            )}
                                            key={"deactivate-button"}
                                            disabled={this.props.recreditViewOnlyPermission}
                                        >
                                                Remove
                                        </Button>
                                    ] :
                                    [
                                        <Button
                                            type="link"
                                            onClick={this.props.viewDocument.bind(
                                                null,
                                                __.file.file_name,
                                                __.file.file
                                            )}
                                            key={"view-button"}
                                        >
                                            View
                                        </Button>
                                    ]
                            }
                        >
                            {__.file.file_name}
                        </ListItem>
                    )).toList().toArray()}
            </AntList>
        );
    }

    render() {
        return this.props.categories ? (
            this.props.categories.filter(_ => _.id === 12).map(_ => {
                return (
                    !this.props.droppable && this.props.documents.find(__ => __.document === _.id) ?
                        <DropTargetCard
                            type={"inner"}
                            className={"no-shadow mb-5"}
                            key={_.name}
                            title={_.name}
                            caseId={this.props.caseId}
                            companyId={this.props.companyId}
                            associateId={this.props.associateId}
                            bankId={this.props.bankId}
                            documentId={_.id}
                            documentType={_.document_type}
                            canDrop={() => this.props.droppable}
                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            extra={this.props.deletable ? [
                                <DirectFileUpload
                                    key={"direct-upload"}
                                    companyId={this.props.companyId}
                                    uploadFiles={this.uploadAndAttachFile.bind(
                                        null,
                                        _.id,
                                        _.document_type
                                    )}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            ] : null}
                        >
                            {this.renderList(_)}
                        </DropTargetCard> : this.props.droppable ? (
                            <DropTargetCard
                                type={"inner"}
                                className={"no-shadow mb-5"}
                                key={_.name}
                                title={_.name}
                                caseId={this.props.caseId}
                                companyId={this.props.companyId}
                                associateId={this.props.associateId}
                                bankId={this.props.bankId}
                                documentId={_.id}
                                documentType={_.document_type}
                                canDrop={() => this.props.droppable}
                                extra={this.props.deletable ? [
                                    <DirectFileUpload
                                        key={"direct-upload"}
                                        companyId={this.props.companyId}
                                        uploadFiles={this.uploadAndAttachFile.bind(
                                            null,
                                            _.id,
                                            _.document_type
                                        )}
                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    />
                                ] : null}
                            >
                                {this.renderList(_)}
                            </DropTargetCard>
                        ) : null
                );
            })
        ) : (
            <Empty />
        );
    }
}

BankDocumentView.propTypes = {
    droppable: PropTypes.boolean,
    deletable: PropTypes.boolean,
    isOver: PropTypes.boolean,
    categories: PropTypes.array,
    documents: PropTypes.object,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    associateId: PropTypes.number,
    bankId: PropTypes.number,
    updateDocument: PropTypes.func,
    uploadFiles: PropTypes.func,
    attachDocument: PropTypes.func,
    viewDocument: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default BankDocumentView;
